<template>
  <div class="footer">
    <img
      src="/static/img/footer/NP_Logo_web.png"
      style="width: 400px;max-width: 100%;"
      alt="logo"
    />
    <div class="copy-container">
      <strong style="color:rgb(140, 140, 140);">
        Copyright © NUTS POKER. All Rights Reserved.
      </strong>
      <div class="icon-list">
        <div style="margin-right: 40px;" id="anj-d0549dbb-b507-44d7-8358-b4836b078fd4" data-anj-seal-id="d0549dbb-b507-44d7-8358-b4836b078fd4" data-anj-image-size="60" data-anj-image-type="basic-small"></div>
        <a
          href="https://access.gaminglabs.com/Certificate/Index?i=552"
          target="_blank"
          ><img class="icon icon_07" src="/static/img/home/gli.jpeg"
        /></a>
        <a><img class="icon icon_08" src="/static/img/home/icon_08.png"/></a>
        <a
          ><img class="icon icon_09" src="/static/img/home/GambleAware.png"
        /></a>
        <a><img class="icon icon_10" src="/static/img/home/icon_10.png"/></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: "",
      show: false,
      FB_VERSON: "",
      checked: false,
      subscribe_error: "",
      subscribe_step: 0,
      currentYear: new Date().getFullYear(),
    };
  },
  props: ["hidedata"],
  mounted() {
    anj_d0549dbb_b507_44d7_8358_b4836b078fd4.init()
  },
  methods: {
    toBottom() {
      if (
        navigator.userAgent.indexOf("Android") > -1 ||
        navigator.userAgent.indexOf("Adr") > -1
      ) {
        document.querySelector(".footer").scrollIntoView(true);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.footer {
  width: 100%;
  margin: 200px 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;

  .copy-container {
    width: 100%;
    margin-top: 50px;
    padding-top: 50px;
    border-top: 4px solid #181818;
    display: flex;
    justify-content: space-around;
    .icon-list {
      display: flex;
      align-items: center;
      a[href] {
        cursor: pointer;
      }
      .icon {
        height: 40px;
        margin-right: 40px;
        &.icon_06 {
          height: 60px;
        }
      }
    }
  }
}
</style>
